import React from 'react';
import "../css/Contact.css"
import FooterLink from './FooterLink'

const Contact = () => {
  return (
    <div className="contact">
      <div className="contact-form">
        <h3>FIND ME</h3>
        <div className="footer-row">
          <FooterLink
            link='https://www.facebook.com/regina.wung'
            imageLink={require('../images/Facebook.png')}
            socialMediaType="Facebook"
          />
          <FooterLink
            link='https://www.linkedin.com/in/alex-marvick'
            imageLink={require('../images/LinkedIn.png')}
            socialMediaType="LinkedIn"
          />
          <FooterLink
            link='https://www.github.com/amarvick'
            imageLink={require('../images/Github.jpeg')}
            socialMediaType="Github"
          />
          <FooterLink
            link='mailto:amarvick94@gmail.com'
            imageLink={require('../images/Email.png')}
            socialMediaType="Github"
          />
        </div>
      </div>
    </div>
  );
};

export default Contact;
